<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" align-self="center">
        <div class="d-flex flex-column">
          <div class="d-flex justify-center">
            <img src="logo_primary.svg" width="450">
          </div>
          <p class="d-flex justify-center text-center mt-8 mb-6">
            MILK.CLOUDをご利用いただくにはログインが必要です。<br>
            以下のボタンからログイン画面にアクセスできます。
          </p>
          <div class="d-flex justify-center">
            <v-btn
              color="brandPrimary white--text"
              depressed
              large
              @click="loginPageClick"
            >
              <v-icon left>
                mdi-login
              </v-icon>
              ログイン画面へ
            </v-btn>
          </div>
          <div class="d-flex justify-center mt-16">
            <v-alert
              dense
              type="info"
              outlined
              prominent
              max-width="455px"
              icon="mdi-bookmark-plus-outline"
              class="d-flex justify-center"
            >
              MILK.CLOUDをブックマークに登録する場合は、<br>
              こちらのページを登録してください。
            </v-alert>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  layout: 'guest',
  middleware: [
    'auth'
  ],
  async asyncData (context) {
    const {
      query
    } = context

    if (typeof query.code !== 'undefined' && query.code !== null && query.code !== '' &&
      typeof query.state !== 'undefined' && query.state !== null && query.state !== ''
    ) {
      await context.app.$getAccessToken()
    }
  },
  methods: {
    loginPageClick () {
      this.$login()
    }
  }
}
</script>
